// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3DWiC","rootCenter":"LoadMoreObserver_rootCenter__3sw2-","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2XGrH"};